import * as Yup from 'yup';

const ketInformationValidationSchema = Yup.object().shape({
    companyCode: Yup.number().integer().required('Company code is required'),
    employeeCode: Yup.number().integer().required('Employee code is required'),
    companyName: Yup.string().trim().required('Company name is required'),
    placeOfWork: Yup.string().trim().required('Place of work is required'),
    employeeFullName: Yup.string().trim().required('Employee full name is required'),
    employeeNRIC: Yup.string().trim().required('Employee NRIC is required'),
    jobTitle: Yup.string().trim(), //.required('Job title is required'),
    mainDuties: Yup.string().trim().nullable(),
    employmentType: Yup.string().trim().nullable(), //.required('Employment type is required'),
    startDate: Yup.date().required('Start date is required'),
    endDate: Yup.date()
        .nullable()
        .min(Yup.ref('startDate'), 'End date cannot be before start date'),
    workingHours: Yup.string().trim().nullable(),
    workingDays: Yup.string().trim().nullable(),
    breakTime: Yup.string().trim().nullable(),
    restDay: Yup.string().trim().nullable(),
    salaryPeriod: Yup.string().trim().nullable(),
    basicPay: Yup.string(), //.typeError('Basic pay must be a string').nullable(),
    grossPay: Yup.string(), // .typeError('Gross pay must be a string').nullable(),
    salaryType: Yup.string().trim().nullable(),
    salaryDate: Yup.string().trim().nullable(),
    fixedAllowance: Yup.string(), //.typeError('Fixed allowance must be a string').nullable(),
    fixedDeduction: Yup.string(), //.typeError('Fixed deduction must be a string').nullable(),
    annualLeave: Yup.string().nullable(),
    sickLeave: Yup.string().nullable(),
    hospitalisationLeave: Yup.string().nullable(),
    otherLeave: Yup.string().nullable(),
    probationLength: Yup.string().trim().nullable(),
    probationStart: Yup.date().nullable(),
    probationEnd: Yup.date()
        .nullable()
        .min(Yup.ref('probationStart'), 'Probation end cannot be before probation start'),
    noticePeriod: Yup.string().trim().nullable(),
    issuedDate: Yup.date().nullable(),
    overtimeDate: Yup.string().trim().nullable(),
    otherSalaryComponents: Yup.string().trim().nullable(),
    overtimeRate: Yup.string(),
    haveCpf: Yup.boolean().required('CPF flag is required'),
    medicalBenefits: Yup.string().trim().nullable(),
    noticePeriodEmployment: Yup.string().trim().nullable(),
});

export default ketInformationValidationSchema;